module.exports = {"653221100":"巴格其镇","653221102":"罕艾日克镇","653221202":"英阿瓦提乡","653221203":"英艾日克乡","653221204":"布扎克乡","653221205":"拉依喀乡","653221206":"朗如乡","653221207":"塔瓦库勒乡","653221208":"伊斯拉木阿瓦提乡","653221209":"色格孜库勒乡","653221210":"喀什塔什乡","653221211":"吾宗肖乡","653221401":"和田县经济新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653221.json
// module id = 3118
// module chunks = 0